export type Primitive =
	| string
	| number
	| boolean
	| bigint
	| symbol
	| null
	| undefined
export type EmptyObject = Record<string, never>
export const EMPTY_OBJECT = {}

export function isPrimitive(val: any): val is Primitive {
	return val !== Object(val)
}

export function isArray<T>(val: any): val is Array<T> {
	return Array.isArray(val)
}

export function isLiteralObject(val: any): val is object {
	return Boolean(val) && val.constructor === Object
}

export function isEmptyObject(obj: object): obj is EmptyObject {
	return Object.keys(obj).length === 0
}

export function mapObject<T extends object, U>(
	obj: T,
	func: (v: T[keyof T]) => U
): { [k in keyof T]: U } {
	const subObjects = Object.entries(obj).map(([k, v]) => ({ [k]: func(v) }))
	return Object.assign({}, ...subObjects)
}

export const areArraysEmpty = (...arrays: Array<any>): boolean => {
	for (let i = 0; i < arrays.length; i++) {
		if (arrays[i].length === 0) {
			return true
		}
	}
	return false
}

export const isSomeNull = <T,>(...values: (T | null)[]) =>
	values.some((value) => value === null)

export const isDefined = <T,>(value: T | null | undefined): value is T =>
	typeof value !== "undefined" && value !== null

export const isNotEmpty = (text: string | undefined | null) => {
	if (text === null) return false

	if (text === undefined) return false

	return text.length > 0
}

export const isSomeTrue = (...values: boolean[]): boolean =>
	values.some(Boolean)
